/**
 * Custom Dropdown Menu Functionality
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;
	const log = (...args) => {
		if (debug) console.log(...args);
	};

	let isDropdownOpen = false; // Track if any dropdown is open
	let activeDropdown = null; // Track the currently opened dropdown

	// Ensure event listener is added only once
	if (window.__DROPDOWN_LISTENER_ADDED__) {
		log("Dropdown listener already added, skipping...");
		return;
	}
	window.__DROPDOWN_LISTENER_ADDED__ = true; // Prevent duplicate event bindings

	document.querySelectorAll('.dropdown-menu__trigger').forEach(trigger => {
		trigger.addEventListener('click', (event) => {
			if (trigger.classList.contains('--select')) {
				log("Ignored click on --select trigger:", trigger);
				return;
			}

			event.preventDefault();
			handleDropdownClick(event, trigger);
		});
	});

	function handleDropdownClick(event, trigger) {
		event.stopPropagation(); // Prevent bubbling
		log('Dropdown trigger clicked:', trigger);

		const dropdownMenu = trigger.closest('.dropdown-menu');

		if (dropdownMenu) {
			trigger.classList.add('--menu');
			log('Added --menu class to:', trigger);

			const isOpened = dropdownMenu.classList.contains('--opened');
			if (isOpened) {
				closeDropdown(dropdownMenu);
			} else {
				openDropdown(dropdownMenu);
			}
		} else {
			log('No parent .dropdown-menu found.');
		}
	}

	document.addEventListener('click', (event) => {
		if (!isDropdownOpen) return;

		// Check if the click is inside an open dropdown
		if (event.target.closest('.dropdown-menu')) return;

		handleOutsideClick();
	});

	function handleOutsideClick() {
		log("Closing dropdown due to outside click");

		if (activeDropdown) {
			closeDropdown(activeDropdown);
		}
	}

	function openDropdown(dropdownMenu) {
		// If another dropdown is already open, close it first
		if (activeDropdown && activeDropdown !== dropdownMenu) {
			closeDropdown(activeDropdown);
		}

		dropdownMenu.classList.add('--opened');
		isDropdownOpen = true;
		activeDropdown = dropdownMenu;
		log('Opened dropdown:', dropdownMenu);
	}

	function closeDropdown(dropdownMenu) {
		dropdownMenu.classList.remove('--opened');
		isDropdownOpen = false;
		activeDropdown = null;
		log('Closed dropdown:', dropdownMenu);
	}
};
